/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, shape, arrayOf, bool, func } from "prop-types";
import { transactionStatus } from "pages/transactions/constants";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import Button from "pages/_components/Button";
import { TransactionSign } from "pages/_components/TransactionCard";
import * as i18n from "util/i18n";
import EcheqMultipleHeaderTicket from "pages/echeck/components/EcheqMultipleHeaderTicket";
import CustomData from "../../../_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import { Spring, config } from "react-spring";
import InfoTag from "pages/echeck/components/InfoTag";
import FormattedAmount from "pages/_components/FormattedAmount";
import { isFinishedWithErrors } from "../../utils"

const CesionTransactionMultipleBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, idTransactionStatus } = transaction;
    const { showMoreData, setShowMoreData } = props;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const isPending = idTransactionStatus === transactionStatus.PENDING;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const { isDesktop } = props;
    const {
        beneficiary = props.beneficiary.document,
        beneficiaryName = props.beneficiary.reference,
        reference = props.reference,
        referencevalue = props.referencevalue,
        caracter = props.caracter || "No a la orden",
        echeqList = props.echeqList,
        cessions = props.cessions || [],
    } = data;

    const getAmoutTotal = () => {
        let total = 0;
        echeqList.forEach((echeq) => {
            total += parseFloat(echeq.monto);
        });
        return total;
    };

    const getCurrency = () => {
        return echeqList[0].moneda;
    }

    const statusCesionTagColor = (cheque_id, cessions) => {
        if (idTransactionStatus == "PENDING")
            return "warning";
        if (idTransactionStatus == "CANCELLED")
            return "error";

        const state = cessions.find((cesion) => cesion.cheque_id === cheque_id)?.error;

        switch (state) {
            case "success":
                return "success";
            case "error":
                return "error";
            default:
                return "success";
        }
    };

    const statusCesionName = (cheque_id, cessions) => {
        let state = cessions.find((cesion) => cesion.cheque_id === cheque_id)?.error;
        if (idTransactionStatus == "PENDING")
            state = "pending";
        if (idTransactionStatus == "CANCELLED")
            state = "cancelled";

        return `echeqs.cesion.status.${state || "success"}`;
    };


    return (
        <div className="ticket__body echeq-endorse">
            <>
                <EcheqMultipleHeaderTicket
                    moneda={getCurrency()}
                    monto={getAmoutTotal()}
                    status={isFinishedWithErrors(transaction?.data?.cessions) ? "FINISHED_WITH_ERRORS" : idTransactionStatus}
                    isDesktop={isDesktop}
                />
                <div className="view-more-data-button">
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <Button
                        aria-expanded={showMoreData ? "true" : "false"}
                        className="more-button"
                        label={buttonLabel}
                        bsStyle="link"
                        onClick={handleSeeMoreData}
                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                </div>
                <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                    <div className="ticket-section">
                        <div
                            style={{
                                display: "block",
                                width: "100%",
                                gridColumn: "1 / -1",
                            }}>
                            <GridTable>
                                <GridTable.Container className="ticket-gap">
                                    {data.action !== "ANULATE-CESION" && (
                                        <>
                                            <GridTable.Data columnStart={1} rowStart={1}>
                                                <CustomData
                                                    titleText="echecks.beneficiary"
                                                    titleTextType="I18N"
                                                    valueText={beneficiaryName}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={2} rowStart={1}>
                                                <CustomData
                                                    titleText="echecks.document"
                                                    titleTextType="I18N"
                                                    valueText={beneficiary}
                                                />
                                            </GridTable.Data>

                                            <GridTable.Data columnStart={1} rowStart={2}>
                                                <CustomData
                                                    titleText="echecks.echeckReference"
                                                    titleTextType="I18N"
                                                    valueText={reference}
                                                    valueTextType="TEXT"
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={2} rowStart={2}>
                                                <CustomData
                                                    titleText="echecks.echeckReferenceValue"
                                                    titleTextType="I18N"
                                                    valueText={referencevalue}
                                                    valueTextType="TEXT"
                                                />
                                            </GridTable.Data>

                                            <GridTable.Data columnStart={1} rowStart={3}>
                                                <CustomData
                                                    titleText="echecks.echeckNature"
                                                    titleTextType="I18N"
                                                    valueText={caracter}
                                                    valueTextType="TEXT"
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={2} rowStart={3}>
                                                <CustomData
                                                    titleText="echecks.currency"
                                                    titleTextType="I18N"
                                                    valueText={getCurrency()}
                                                />
                                            </GridTable.Data>


                                            <GridTable.Data columnStart={1} rowStart={4}>
                                                <CustomData
                                                    titleText="echecks.quantity.echeqs"
                                                    titleTextType="I18N"
                                                    valueText={echeqList.length}
                                                    valueTextType="TEXT"
                                                />
                                            </GridTable.Data>

                                            <GridTable.Data columnStart={2} rowStart={4}>
                                                <CustomData
                                                    titleText="echecks.monto.total"
                                                    titleTextType="I18N"
                                                    valueText={getAmoutTotal()}
                                                    valueTextType={getCurrency()}
                                                />
                                            </GridTable.Data>
                                        </>
                                    )}
                                    {data.action === "ANULATE-CESION" && (
                                        <>
                                            <GridTable.Data columnStart={1} rowStart={1}>
                                                <CustomData
                                                    titleText="echecks.echeckNature"
                                                    titleTextType="I18N"
                                                    valueText={caracter}
                                                    valueTextType="TEXT"
                                                />
                                            </GridTable.Data>

                                            <GridTable.Data columnStart={2} rowStart={1}>
                                                <CustomData
                                                    titleText="echecks.currency"
                                                    titleTextType="I18N"
                                                    valueText={getCurrency()}
                                                />
                                            </GridTable.Data>

                                            <GridTable.Data columnStart={1} rowStart={2}>
                                                <CustomData
                                                    titleText="echecks.quantity.echeqs"
                                                    titleTextType="I18N"
                                                    valueText={echeqList.length}
                                                    valueTextType="TEXT"
                                                />
                                            </GridTable.Data>

                                            <GridTable.Data columnStart={2} rowStart={2}>
                                                <CustomData
                                                    titleText="echecks.monto.total"
                                                    titleTextType="I18N"
                                                    valueText={getAmoutTotal()}
                                                    valueTextType={getCurrency()}
                                                />
                                            </GridTable.Data>

                                            <GridTable.Data columnStart={1} rowStart={3}>
                                                <CustomData
                                                    titleText="echecks.motive.label"
                                                    titleTextType="I18N"
                                                    valueText={data.specialAttribute}
                                                    valueTextType="TEXT"
                                                />
                                            </GridTable.Data>
                                        </>
                                    )}
                                </GridTable.Container>
                            </GridTable>
                        </div>
                        <div className="ticket__divider divider_2 inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <div
                            style={{
                                display: "block",
                                width: "100%",
                                gridColumn: "1 / -1",
                            }}>
                            <GridTable>
                                {isDesktop && (
                                    <GridTable.Container className="three-cols" columns={3} rows={1}>
                                        <GridTable.Data columnWidth={1} columnStart={1} rowStart={1}>
                                            <CustomText
                                                className="title-discounts"
                                                text={""}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data columnWidth={1} columnStart={2} rowStart={1}>
                                            <CustomText
                                                className="title-discounts font-bold"
                                                text={i18n.get("echecks.status")}
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data columnWidth={1} columnStart={3} rowStart={1} alignX="center">
                                            <CustomText
                                                className="title-discounts font-bold"
                                                text={i18n.get("echeq.transaction.amount.label")}
                                            />
                                        </GridTable.Data>
                                    </GridTable.Container>
                                )}
                                <Spring
                                    config={config.stiff}
                                    from={{ height: 0 }}
                                    to={{
                                        height: echeqList.length ? "auto" : 0,
                                        overflow: "hidden",
                                    }}>
                                    {(styles) => (
                                        <div className="form-group" style={styles}>
                                            <div className="form-group-control-list">
                                                {echeqList.map((echeq, index) => (
                                                    <GridTable.Container
                                                        className="three-cols"
                                                        columns={3}
                                                        rows={1}
                                                        key={index}>
                                                        <GridTable.Data columnWidth={1} columnStart={1} rowStart={1}>
                                                            {isDesktop ? (
                                                                <CustomText text={`Echeq ${echeq.cheque_numero}`} />
                                                            ) : (
                                                                <CustomData
                                                                    titleText="detail.discounts.echek.id"
                                                                    titleTextType="I18N"
                                                                    valueText={`Echeq ${echeq.cheque_numero}`}
                                                                />
                                                            )}
                                                        </GridTable.Data>
                                                        <GridTable.Data columnWidth={1} columnStart={2} rowStart={1}>
                                                            {isDesktop ? (
                                                                <InfoTag
                                                                    type="info"
                                                                    message={i18n.get(
                                                                        statusCesionName(echeq.cheque_id, cessions)
                                                                    )}
                                                                    tagBackground={statusCesionTagColor(
                                                                        echeq.cheque_id, cessions,
                                                                    )}
                                                                />
                                                            ) : (
                                                                <CustomData
                                                                    titleText="payments.table.status"
                                                                    titleTextType="I18N"
                                                                    valueText={<InfoTag
                                                                        type="info"
                                                                        message={i18n.get(
                                                                            statusCesionName(echeq.cheque_id, cessions)
                                                                        )}
                                                                        tagBackground={statusCesionTagColor(
                                                                            echeq.cheque_id, cessions,
                                                                        )}
                                                                    />}
                                                                />
                                                            )}

                                                        </GridTable.Data>
                                                        <GridTable.Data columnWidth={1} columnStart={3} rowStart={1} alignX="center">
                                                            {isDesktop ? (
                                                                <CustomText
                                                                    text={<FormattedAmount currency={echeq.moneda} quantity={echeq.monto} />}
                                                                    textType="TEXT"
                                                                />
                                                            ) : (
                                                                <CustomData
                                                                    titleText="echeq.transaction.amount.label"
                                                                    titleTextType="I18N"
                                                                    valueText={<FormattedAmount currency={echeq.moneda} quantity={echeq.monto} />}
                                                                    textType="TEXT"
                                                                />
                                                            )}
                                                        </GridTable.Data>
                                                        {index !== echeqList.length - 1 && !isDesktop && (
                                                            <div className="ticket__divider inside-ticket__body">
                                                                <div className="ticket__notch ticket__notch--left" />
                                                                <div className="ticket__notch ticket__notch--right" />
                                                            </div>
                                                        )}
                                                    </GridTable.Container>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </Spring>
                            </GridTable>
                        </div>
                        <TransactionSign
                            isSmall
                            creationTime
                            hasVaucher
                            isDesktop={isDesktop}
                            noDate={isPending}
                            showMoreData={showMoreData}
                        />
                    </div>
                </div>
            </>
        </div>
    );
};

CesionTransactionMultipleBody.propTypes = {
    beneficiary: shape({
        reference: string,
        document: string,
    }),
    echeqList: arrayOf(echeqPropTypes),
    address: string,
    referencevalue: string,
    reference: string,
    isDesktop: bool.isRequired,
    showMoreData: bool,
    setShowMoreData: func,
};

CesionTransactionMultipleBody.defaultProps = {
    beneficiary: {
        reference: "",
        document: "",
    },
    echeqList: [],
    address: "",
    referencevalue: "",
    reference: "-",
    showMoreData: false,
    setShowMoreData: () => {},
};

export default CesionTransactionMultipleBody;
